import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import { useAuthStore } from "@/store/auth/login";

import ListSegmentsPage from "../pages/segments/ListSegmentsPage.vue";
import ListCampaignsPage from "../pages/campaigns/ListCampaignsPage.vue";
import SegmentPage from "../pages/segments/SegmentPage.vue";
import CampaignPage from "@/pages/campaigns/CampaignPage.vue";

import LoginPage from "../pages/auth/LoginPage.vue";
import PrivacyPolicyPage from "../pages/auth/PrivacyPolicyPage.vue";
import PersonalDataPage from "../pages/auth/PersonalDataPage.vue";
import PersonalAccountPage from "../pages/auth/PersonalAccountPage.vue";
import ChangePasswordPage from "@/pages/auth/ChangePasswordPage.vue";
import RecoveryPasswordPage from "@/pages/auth/RecoveryPasswordPage.vue";
import SignupPage from "@/pages/auth/SignupPage.vue";
import RegisterConfirmPage from "@/pages/auth/RegisterConfirmPage.vue";

import OrganizationsPage from "@/pages/dictionaries/OrganizationsPage.vue";
import OrganizationPage from "@/pages/dictionaries/OrganizationPage.vue";
import UserPage from "@/pages/dictionaries/UserPage.vue";
import UsersPage from "@/pages/dictionaries/UsersPage.vue";
import SettingsPage from "@/pages/settings/SettingsPage.vue";
import AdsCabinetsPage from "@/pages/dictionaries/AdsCabinetsPage.vue";
import AdsCabinetPage from "@/pages/dictionaries/AdsCabinetPage.vue";
import PlatformPage from "@/pages/dictionaries/PlatformPage.vue";
import PlatformsPage from "@/pages/dictionaries/PlatformsPage.vue";
import EstimationParamPage from "@/pages/dictionaries/EstimationParamPage.vue";
import EstimationParamsPage from "@/pages/dictionaries/EstimationParamsPage.vue";
import WorkbookPage from "@/pages/dictionaries/WorkbookPage.vue";
import WorkbooksPage from "@/pages/dictionaries/WorkbooksPage.vue";
import ShopPage from "@/pages/dictionaries/ShopPage.vue";
import ShopsPage from "@/pages/dictionaries/ShopsPage.vue";
import BrandPage from "@/pages/dictionaries/BrandPage.vue";
import BrandsPage from "@/pages/dictionaries/BrandsPage.vue";

import TraficPlanPage from "@/pages/analytics/TraficPlanPage.vue";
import ListTraficPlansPage from "@/pages/analytics/ListTraficPlansPage.vue";
import EstimationSettingsPage from "@/pages/analytics/EstimationSettingsPage.vue";
import DasboardsPage from "@/pages/analytics/DasboardsPage.vue";
import ClientDashboardPage from "@/pages/analytics/ClientDashboardPage.vue";
import PreSalePage from "@/pages/analytics/PreSalePage.vue";
import DemoDashboardsPage from "@/pages/analytics/DemoDashboardsPage.vue";
import TrainingPage from "@/pages/TrainingPage.vue";
import CreativePreviewPage from "@/pages/CreativePreviewPage.vue";
import CoefficientsPage from "@/pages/expenses/CoefficientsPage.vue";
import StatisticsPage from "@/pages/expenses/StatisticsPage.vue";


const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: (to) => {
      const authStore = useAuthStore();
      const payload = authStore.getPayload();
      if (!payload) {
        return '/login';
      }

      return authStore.getStartPage();
    }
  },
  {
    path: "/segments",
    name: "listSegments",
    component: ListSegmentsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/segments/:id",
    name: "segment",
    component: SegmentPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/segments/create",
    name: "segmentCreate",
    component: SegmentPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
  },
  {
    path: "/privacy-policy",
    name: "privacyPolicy",
    component: PrivacyPolicyPage,
  },
  {
    path: "/personal-data-policy",
    name: "personalDataPolicy",
    component: PersonalDataPage,
  },
  {
    path: "/campaigns",
    name: "listCampaigns",
    component: ListCampaignsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/campaigns/:id",
    name: "campaign",
    component: CampaignPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/campaigns/create",
    name: "campaignCreate",
    component: CampaignPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/organizations",
    name: "listOrganizations",
    component: OrganizationsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/users",
    name: "users",
    component: UsersPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/ads-cabinets",
    name: "adsCabinets",
    component: AdsCabinetsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/ads-cabinets/create",
    name: "adsCabinetCreate",
    component: AdsCabinetPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/ads-cabinets/:id",
    name: "adsCabinet",
    component: AdsCabinetPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/organizations/:id",
    name: "organization",
    component: OrganizationPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/organizations/create",
    name: "organizationCreate",
    component: OrganizationPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/users/:id",
    name: "user",
    component: UserPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/users/create",
    name: "userCreate",
    component: UserPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/estimation-params",
    name: "estimationParams",
    component: EstimationParamsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/estimation-params/create",
    name: "estimationParamCreate",
    component: EstimationParamPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/estimation-params/:id",
    name: "estimationParam",
    component: EstimationParamPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/shops",
    name: "shops",
    component: ShopsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/shops/create",
    name: "shopCreate",
    component: ShopPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/shops/:id",
    name: "shop",
    component: ShopPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/brands",
    name: "brands",
    component: BrandsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/brands/create",
    name: "brandCreate",
    component: BrandPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/brands/:id",
    name: "brand",
    component: BrandPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/lk",
    name: "personalAccount",
    component: PersonalAccountPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/change-password",
    name: "changePassword",
    component: ChangePasswordPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: RecoveryPasswordPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/signup",
    name: "signup",
    component: SignupPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/register-confirm",
    name: "registerConfirm",
    component: RegisterConfirmPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/settings",
    name: "settings",
    component: SettingsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/platforms",
    name: "platforms",
    component: PlatformsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/platforms/create",
    name: "platformCreate",
    component: PlatformPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/platforms/:id",
    name: "platform",
    component: PlatformPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/workbooks/create",
    name: "workbookCreate",
    component: WorkbookPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/workbooks",
    name: "workbooks",
    component: WorkbooksPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dictionaries/workbooks/:id",
    name: "workbook",
    component: WorkbookPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/analytics/trafic-plan",
    name: "traficPlanList",
    component: ListTraficPlansPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/analytics/trafic-plan/create",
    name: "traficPlanCreate",
    component: TraficPlanPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/analytics/trafic-plan/:id",
    name: "traficPlan",
    component: TraficPlanPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/analytics/estimation-settings",
    name: "estimationSettings",
    component: EstimationSettingsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/analytics/estimation-settings-dates",
    name: "estimationSettingsDates",
    component: () => import('@/pages/analytics/EstimationSettingsDatePage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/analytics/client-dashboards",
    name: "clientDashboards",
    component: ClientDashboardPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/analytics/dashboards",
    name: "dashboards",
    component: DasboardsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/analytics/pre-sale",
    name: "preSale",
    component: PreSalePage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/analytics/demo/:workbookId?",
    name: "demoDashboards",
    component: DemoDashboardsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/training",
    name: "training",
    component: TrainingPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/creative-preview",
    name: "creativePreview",
    component: CreativePreviewPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/expenses/coefficients",
    name: "coefficients",
    component: CoefficientsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/expenses/statistics",
    name: "expensesStatistics",
    component: StatisticsPage,
    meta: {
      requiresAuth: true,
    },
  },

];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  if (to.name == "login" && localStorage.getItem("access_token")) {
    next(from);
    return;
  }

  if (to.name === "demoDashboards" && localStorage.getItem("access_token")) {
    if (!authStore.user) {
      await authStore.getUserInfo();
    }

    const isDemoOrganization = Boolean(
      authStore.user?.role?.department?.organization?.is_demo
    );

    if (!isDemoOrganization) {
      next({ name: "dashboards" });
      return;
    }
  }

  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !localStorage.getItem("access_token")
  ) {
    next({ name: "login", query: { next: to.fullPath?.toString() } });
  } else {
    next();
  }
});

export default router;
